import { Resume } from '@sr/types';
import { useEffect, useState } from 'react';
import { ref } from '../utils/firebase';

export const useResume = (id: string | undefined): Resume | null => {
  const [resume, setResume] = useState<Resume | null>(null);

  useEffect(() => {
    if (id) {
      // Clear the existing resume
      setResume(null);
      // Setup listener for new resume
      const resumeRef = ref.child(`resumes2/${id}`);
      const listener = resumeRef.on('value', (snap) => {
        const resume = snap.val() as Resume | null;
        setResume(resume);
      });

      return function cleanup() {
        resumeRef.off('value', listener);
      };
    } else {
      setResume(null);
    }
  }, [id]);

  return resume;
};
